import Base from 'records/Base';
import Canvas from 'records/Canvas';

import {
  CANVAS_LOAD_START,
  CANVAS_LOAD_ERROR,
  CANVAS_LOAD_SUCCESS,
  CANVAS_RESET_STATE,
} from 'actions/canvas';

const initialState = new Base({
  loading: false,
  errorMessage: null,
  data: new Canvas(),
});

const actionsMap = {
  [CANVAS_LOAD_START]: (state) => {
    return state.merge({
      loading: true,
      errorMessage: null,
    });
  },
  [CANVAS_LOAD_ERROR]: (state, action) => {
    return state.merge({
      loading: false,
      errorMessage: action.error,
    });
  },
  [CANVAS_LOAD_SUCCESS]: (state, action) => {
    const { domElement, productDefinition, configuration } = action.data;
    return state.merge({
      loading: false,
      errorMessage: null,
      data: new Canvas({
        domElement,
        productDefinition,
        configuration,
      }),
    });
  },
  [CANVAS_RESET_STATE]: () => {
    return initialState;
  },
};

export default function canvas(state = initialState, action = {}) {
  const fn = actionsMap[action.type];
  return fn ? fn(state, action) : state;
}
